"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_info__circle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "tutorials-hi"), /*#__PURE__*/React.createElement("g", {
    id: "e8e989b7-fa78-4381-b978-cc9fcf1f7b72",
    "data-name": "tutorials-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9bd8a5a9-aa25-47fb-a9e9-d919228b48aa",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0667d619-0094-4091-884b-ce16e55fc3f3",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "47943fc9-2422-45d0-b053-390045cbd936",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "87ce0842-21f5-49e6-910c-20b3ae571fe4",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "014421e6-7fe8-4fec-aaf7-34b96c4be8b6",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13f6c859-263f-49c0-bb7c-6f06e57a0018",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b9ed7cc5-1e3c-46a3-9565-3af93e6fc790",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "357f4b72-87a5-44c9-a89c-2ecadce4d8f3",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fc3e043a-21b4-4e45-8dca-5c0a78a12055",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.12a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.12Z",
    transform: "translate(0 -0.12)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "cba77c19-4277-4b71-8540-f6a2a4dd6401",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 135.87,
    x2: 96,
    y2: 79.89,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "dff8c29d-943a-446b-8f50-ebc47fa72391",
    "data-name": "<Pfad>",
    x1: 85.75,
    y1: 135.92,
    x2: 106.25,
    y2: 135.92,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "2c7fcf9d-f7d9-48e3-8ef1-8ed74553ec21",
    "data-name": "<Pfad>",
    x1: 84.42,
    y1: 79.88,
    x2: 96,
    y2: 79.88,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a42c811d-cc63-4bbb-9706-b5a80c61a9cb",
    "data-name": "<Pfad>",
    cx: 93.8,
    cy: 60.5,
    r: 6,
    fill: "#e60000"
  }))))))))))));
}

var _default = ic_info__circle;
exports.default = _default;